import "./style.scss";

import domReady from "@wordpress/dom-ready";

function employeeQuotes() {
  const blocks = document.querySelectorAll(".wp-block-intempus-employee-quotes");

  blocks.forEach((block) => {
    const popupContent = block.querySelector(".mockup-popup-content");
    const quotes = block.querySelectorAll(".wp-block-intempus-quote-box");

    function activate(quote) {
      const token = "quote-activate";
      block.querySelectorAll(`.${token}`).forEach((elem) => elem.classList.remove(token));
      quote.classList.add(token);
      popupContent.innerHTML = quote.firstChild.textContent;
    }

    quotes.forEach((quote, index) => {
      if (index === 0) activate(quote);
      quote.addEventListener("click", activate.bind(null, quote));
    });
  });
}

domReady(employeeQuotes);
